import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { logError } from 'services/logging/logging';
import { formatCurrency } from 'support/helpers/currency/currency';
import { GenericError } from 'support/helpers/errors/errors';
import { DocumentTypeWithVirtual, MessageV2DTO, PartnerDTO } from 'support/types';
import { SidebarSection } from 'components/Sidebar/SidebarSection/SidebarSection';
import { SidebarTableContent } from 'components/Sidebar/SidebarTableContent/SidebarTableContent';
import { WebEDISidebar } from 'components/WebEDI/WebEDISidebar/WebEDISidebar';

type MissingMessageSidebarProps = {
  message: MessageV2DTO;
  relatedTransactions: Array<MessageV2DTO> | undefined;
  currentPartner: PartnerDTO;
};

const enabledMissingDocuments: Array<string> = [
  DocumentTypeWithVirtual.invoice,
  DocumentTypeWithVirtual.creditNote,
  DocumentTypeWithVirtual.debitNote,
  DocumentTypeWithVirtual.serviceInvoice,
];
export const MissingMessageSidebar = ({ message, relatedTransactions, currentPartner }: MissingMessageSidebarProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!enabledMissingDocuments.includes(message.type)) {
      logError(
        new GenericError('MissingMessageUI: Unsupported document type', {
          messageId: message.id,
          documentType: message.type,
        }),
      );
    }
  }, [message.id, message.type]);

  return (
    <WebEDISidebar
      document={message}
      relatedTransactions={relatedTransactions}
      currentPartner={currentPartner}
      documentOriginApp={null}
    >
      <SidebarSection>
        <SidebarTableContent
          sections={[]}
          footer={
            typeof message.canonical?.due_amount === 'number'
              ? {
                  label: t('webedi:missingDocument.summary.due_amount'),
                  value: formatCurrency(message.canonical?.due_amount, 'EUR'),
                }
              : undefined
          }
        />
      </SidebarSection>
    </WebEDISidebar>
  );
};
